/*
 * @Author       : suzhen
 * @Email        : suzhen@dianzhong.com
 * @Date         : 2023-02-20 13:38:08
 * @LastEditors: suzhen suzhen@dianzhong.com
 * @LastEditTime: 2024-04-18 13:36:54
 * @Description  : store属性值
 */

const getters = {
  token: state => state.user.token,
  mobile: state => state.user.mobile,
  admin_id: state => state.user.admin_id,
  id: state => state.user.userId,
  account_list: state => state.user.account_list,
  hasKsandmi: state => state.user.hasKsandmi,
  userAccount: state=> state.user.userAccount,
  teamSlefInviteCode: state=> state.user.teamSlefInviteCode,
  teamLeaderBenefit: state=> state.user.teamLeaderBenefit,
  companyList: state=> state.user.company_list,
  filterMap: state=> state.user.filter_list,
  mediaList: state=> state.user.media_list,
  no_see_count: state=> state.user.no_see_count,
}
export default getters